/* eslint-disable no-restricted-globals */
import Vue from "vue";
import Router from "vue-router";
import Email from "@/views/Email";
import PersonalForm from "@/views/PersonalForm";
import AddressForm from "@/views/AddressForm";
import SimpleContract from "@/views/SimpleContract";
import Success from "@/views/Success";
import Declarations from "@/views/Declarations";
import BankForm from "@/views/BankForm";
import Recovery from "@/views/Recovery";
import Profiling from "@/views/Profiling";
import store from "@/store";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "email",
      component: Email,
    },
    {
      path: "/userform",
      name: "personalform",
      component: PersonalForm,
      beforeEnter: (to, from, next) => {
        if (store.state.step < 1 || store.state.step >= 6) {
          next("/");
        } else {
          next();
        }
      },
    },
    {
      path: "/addressform",
      name: "addressform",
      component: AddressForm,
      beforeEnter: (to, from, next) => {
        if (store.state.step < 2 || store.state.step >= 6) {
          next("/");
        } else {
          next();
        }
      },
    },
    {
      path: "/profiling",
      name: "profiling",
      component: Profiling,
      beforeEnter: (to, from, next) => {
        if (store.state.step < 3 || store.state.step >= 6) {
          next("/");
        } else {
          next();
        }
      },
    },
    {
      path: "/declarations",
      name: "declarations",
      component: Declarations,
      beforeEnter: (to, from, next) => {
        if (store.state.step < 4 || store.state.step >= 6) {
          next("/");
        } else {
          next();
        }
      },
    },
    {
      path: "/contracts",
      name: "contracts",
      component: SimpleContract,
      beforeEnter: (to, from, next) => {
        if (store.state.step < 5 || store.state.step >= 6) {
          next("/");
        } else {
          next();
        }
      },
    },
    {
      path: "/bankform",
      name: "bankform",
      component: BankForm,
      beforeEnter: (to, from, next) => {
        if (store.state.step < 6 || store.state.step >= 7) {
          next("/");
        } else {
          next();
        }
      },
    },
    {
      path: "/success",
      name: "success",
      component: Success,
      beforeEnter: (to, from, next) => {
        if (store.state.step < 7) {
          next("/");
        } else {
          next();
        }
      },
    },
    {
      path: "/recover",
      name: "recover",
      component: Recovery,
    },
  ],
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((toRoute, fromRoute, next) => {
  let title = "Registro Ameris";
  if (location.href.includes("brolly")) {
    title = "Registro Brolly";
  }
  if (location.href.includes("relif")) {
    title = "Registro Relif";
  }
  window.document.title = title;
  next();
});

export default router;
